export enum SpecialDIIds {
  rootDI = -1,
  headerDI = -2,
  footerDI = -3,
  pageHeaderDI = -4,
  pageFooterDI = -5,
  layoutHeaderDI = -10,
  layoutFooterDI = -11,
  layoutLeftDI = -12,
  layoutRightDI = -13
}
